import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const VetQuoteContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$4',
  maxWidth: '900px',
  textAlign: 'center',
})

export const Quote = styled('p', {
  fontFamily: '$display',
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  color: '$accent-white',

  '@bp2': {
    fontSize: '$h2',
    lineHeight: '$h2',
    letterSpacing: '$h2',
  },
})

export const Attribution = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$1',
})

export const AttributionText = styled(Text, {
  fontFamily: '$label',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  color: '$accent-white',
})
